import { render, staticRenderFns } from "./SingUp.vue?vue&type=template&id=1e29ea54&scoped=true&"
import script from "./SingUp.vue?vue&type=script&lang=js&"
export * from "./SingUp.vue?vue&type=script&lang=js&"
import style0 from "./SingUp.vue?vue&type=style&index=0&id=1e29ea54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e29ea54",
  null
  
)

export default component.exports